/*------------------------------------------------------------------
Ella Theme Custom Script - Anti-Cart-Open & Network Interceptor (Complete)
-------------------------------------------------------------------*/
(function ($) {
    var $body = $('body'),
        $doc = $(document),
        $html = $('html'),
        $win = $(window);

    // ==========================================
    // 1. GLOBAL VALIDATION CHECK
    // ==========================================
    function isVariantSelectionMissing() {
        var isMissing = false;
        
        // Check visible Dropdowns
        $('.selector-wrapper select:visible, .productView-options select:visible, select[id*="Option"]:visible').each(function () {
            var val = $(this).val();
            if (!val || val.trim().toLowerCase() === 'choose your option' || val === '') {
                isMissing = true;
            }
        });

        // Check visible Swatches
        $('.swatch:visible, .productView-options .swatch:visible').each(function () {
            if ($(this).find('input[type="radio"]:checked').length === 0) {
                isMissing = true;
            }
        });

        return isMissing;
    }

    function forceCloseCartDrawer() {
        // Ella theme ki tamam cart drawer classes ko remove karna taake drawer khule hi nahi
        $('body, html').removeClass('cart-sidebar-open open-cart-sidebar open-cart preview-cart-open');
        $('.halo-cart-sidebar, .previewCart, #cart-drawer, .wrapper-cart-drawer').removeClass('is-open active');
    }

    // ==========================================
    // 2. BUTTON CLICK & FORM SUBMIT INTERCEPTOR (STOPS DRAWER)
    // ==========================================
    // Capture phase (true) use kiya hai taake Ella ke click script se pehle chalay
    document.addEventListener('click', function (e) {
        var $target = $(e.target);
        if ($target.closest('[data-btn-addtocart], button[name="add"], .product-form__submit, .ajax-to-cart-btn').length) {
            if (isVariantSelectionMissing()) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation(); // Ella ke drawer script ko chalne se rokta hai
                
                alert("Please select a variant for adding in cart");
                forceCloseCartDrawer();
                
                setTimeout(forceCloseCartDrawer, 50); // Safety double check
                return false;
            }
        }
    }, true);

    document.addEventListener('submit', function (e) {
        var $target = $(e.target);
        if ($target.attr('action') && $target.attr('action').indexOf('/cart/add') !== -1) {
            if (isVariantSelectionMissing()) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                alert("Please select a variant for adding in cart");
                forceCloseCartDrawer();
                return false;
            }
        }
    }, true);

    // ==========================================
    // 3. NETWORK LEVEL INTERCEPTOR (SAFETY NET)
    // ==========================================
    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
        const url = args[0];
        if (typeof url === 'string' && url.includes('/cart/add')) {
            if (isVariantSelectionMissing()) {
                forceCloseCartDrawer();
                return new Response(JSON.stringify({ error: "Variant not selected" }), {
                    status: 422,
                    headers: { 'Content-Type': 'application/json' }
                });
            }
        }
        return originalFetch.apply(this, args);
    };

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function(method, url) {
        if (typeof url === 'string' && url.includes('/cart/add')) {
            const originalSend = this.send;
            this.send = function(...args) {
                if (isVariantSelectionMissing()) {
                    forceCloseCartDrawer();
                    return;
                }
                return originalSend.apply(this, args);
            };
        }
        return originalOpen.apply(this, arguments);
    };

    // ==========================================
    // 4. ELLA THEME STANDARD VARIANT LOGIC
    // ==========================================
    document.addEventListener("DOMContentLoaded", function () {
        if (!Ella.isRunningInIframe()) { 
            Ella.initVariantFix();
        }
    });

    var Ella = {
        initVariantFix: function () {
            var productViewSlt = '.halo-productView, .quickView';
            this.simplifiedOptions = window.simplifiedOptions || {}; 
            this.mappingConfig = this.simplifiedOptions.mapping || [];

            if ($(productViewSlt).length) {
                this.detectProductViews(productViewSlt);
            }
        },

        detectProductViews: function (selector) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var $scope = $(entry.target);
                        if (!$scope.data('variant-fix-applied')) {
                            Ella.applySimplifiedLogic($scope);
                            $scope.data('variant-fix-applied', true);
                        }
                    }
                });
            });

            $(selector).each(function () {
                observer.observe(this);
            });
        },

        applySimplifiedLogic: function ($scope) {
            var productData = $scope.find('[data-json-product]').data('json-product');
            if (!productData) return;

            var processedVariants = this.processProductVariants(productData);
            if ($.isEmptyObject(processedVariants)) return;

            $scope.data('processed-variants', processedVariants);
            var uniqueOptions = this.extractUniqueOptions(processedVariants);
            this.updateOptionDropdowns($scope, uniqueOptions);
            this.bindVariantChangeEvent($scope);
            
            this.checkCurrentSelectionAndToggleButton($scope);
        },

        processProductVariants: function (productData) {
            var processedVariants = {};
            var currentLanguageOptions = productData.options;

            $.each(productData.variants, function (index, variant) {
                var variantOptions = (variant.options.length > 0) ? variant.options : variant.option_values; 
                var simplifiedKey = variantOptions.join(' / ');

                if (!processedVariants[simplifiedKey]) {
                    processedVariants[simplifiedKey] = {
                        variantId: variant.id,
                        available: variant.available,
                        price: variant.price,
                        compareAtPrice: variant.compare_at_price,
                        options: {}
                    };
                    
                    $.each(currentLanguageOptions, function(optIndex, optName) {
                        processedVariants[simplifiedKey].options[optName] = variantOptions[optIndex];
                    });
                }
            });

            $.each(processedVariants, function (key, data) {
                $.each(Ella.mappingConfig, function(mIndex, map) {
                    if (data.options[map.optionName] && map.values) {
                        var originalValue = data.options[map.optionName];
                        if (map.values[originalValue]) {
                            processedVariants[key].options[map.optionName] = map.values[originalValue];
                        }
                    }
                });
            });

            return processedVariants;
        },

        extractUniqueOptions: function (processedVariants) {
            var uniqueOptions = {};

            $.each(processedVariants, function (key, data) {
                $.each(data.options, function (optName, optValue) {
                    if (!uniqueOptions[optName]) {
                        uniqueOptions[optName] = new Set();
                    }
                    uniqueOptions[optName].add(optValue);
                });
            });

            $.each(uniqueOptions, function (optName, optSet) {
                uniqueOptions[optName] = Array.from(optSet);
            });

            return uniqueOptions;
        },

        updateOptionDropdowns: function ($scope, uniqueOptions) {
            var $optionWrappers = $scope.find('.swatch, .selector-wrapper');

            $optionWrappers.each(function (index, wrapper) {
                var $wrapper = $(wrapper);
                var optionName = $wrapper.attr('data-option-index-vig') || $wrapper.attr('data-option-name');
                
                if (!optionName) {
                    var labelText = $wrapper.find('.form-label').text();
                    optionName = labelText.split(':')[0].trim();
                }

                if (uniqueOptions[optionName]) {
                    if ($wrapper.hasClass('swatch')) {
                        var $labels = $wrapper.find('.swatch-label');
                        $labels.each(function(lIndex, label) {
                            var $label = $(label);
                            var originalValue = $label.attr('title') || $label.text().trim();
                            
                            if (!uniqueOptions[optionName].includes(originalValue)) {
                                $label.closest('.swatch-element').hide();
                            } else {
                                $label.closest('.swatch-element').show();
                            }
                        });
                    } else if ($wrapper.hasClass('selector-wrapper')) {
                        var $select = $wrapper.find('select');
                        var selectedValue = $select.val();
                        
                        $select.find('option').each(function(oIndex, option) {
                            var $option = $(option);
                            var optVal = $option.val();
                            
                            if (optVal && optVal.trim().toLowerCase() !== 'choose your option' && optVal !== '' && !uniqueOptions[optionName].includes(optVal)) {
                                $option.hide();
                            } else {
                                $option.show();
                            }
                        });

                        var $selectedOption = $select.find('option').filter(function() {
                            return $(this).val() === selectedValue;
                        });

                        if ($selectedOption.is(':hidden')) {
                            var $firstVisible = $select.find('option:not(:hidden)').filter(function() {
                                return $(this).val() && $(this).val().trim().toLowerCase() !== 'choose your option' && $(this).val() !== '';
                            }).first();
                            
                            if ($firstVisible.length) {
                                $select.val($firstVisible.val()).trigger('change');
                            }
                        }
                    }
                }
            });
        },

        bindVariantChangeEvent: function ($scope) {
            var $inputs = $scope.find('.productView-options .swatch input, .productView-options select');

            $inputs.on('change', function () {
                Ella.checkCurrentSelectionAndToggleButton($scope);
            });
        },

        checkCurrentSelectionAndToggleButton: function ($scope) {
            var processedVariants = $scope.data('processed-variants');
            var selectedValues = [];
            var isMissingSelection = false;

            var $dropdowns = $scope.find('.selector-wrapper select:visible');
            var $swatches = $scope.find('.swatch:visible');

            if ($dropdowns.length > 0) {
                $dropdowns.each(function () {
                    var val = $(this).val();
                    if (!val || val.trim().toLowerCase() === 'choose your option' || val === '') {
                        isMissingSelection = true;
                    } else {
                        selectedValues.push(val);
                    }
                });
            }

            if ($swatches.length > 0) {
                $swatches.each(function () {
                    var checkedInput = $(this).find('input[type="radio"]:checked');
                    if (checkedInput.length === 0) {
                        isMissingSelection = true;
                    } else {
                        selectedValues.push(checkedInput.val());
                    }
                });
            }

            var selectedKey = selectedValues.join(' / ');

            if (!isMissingSelection && processedVariants[selectedKey]) {
                var variantData = processedVariants[selectedKey];
                Ella.updateAddToCartButton($scope, variantData);
            }
        },

        updateAddToCartButton: function($scope, variantData) {
            var $productForm = $scope.find('product-form'),
                $addToCartBtn = $productForm.find('[data-btn-addtocart]'),
                $priceDisplay = $scope.find('.productView-price');

            if (variantData.available) {
                $addToCartBtn
                    .text(window.variantStrings ? window.variantStrings.addToCart : "Add to Cart")
                    .prop('disabled', false)
                    .removeClass('is-soldout');
                $addToCartBtn.attr('data-available', 'true');
            } else {
                $addToCartBtn
                    .text(window.variantStrings ? window.variantStrings.soldOut : "Sold Out")
                    .prop('disabled', true)
                    .addClass('is-soldout');
                $addToCartBtn.attr('data-available', 'false');
            }

            if ($priceDisplay.length > 0) {
                var formattedPrice = Shopify.formatMoney(variantData.price, window.money_format);
                $priceDisplay.find('.price-item').html(formattedPrice);
                
                if (variantData.compareAtPrice > variantData.price) {
                    var formattedComparePrice = Shopify.formatMoney(variantData.compareAtPrice, window.money_format);
                    $priceDisplay.find('.price-item--compare').html(formattedComparePrice).show();
                    $priceDisplay.addClass('price--on-sale');
                } else {
                    $priceDisplay.find('.price-item--compare').html('').hide();
                    $priceDisplay.removeClass('price--on-sale');
                }

                if (typeof Currency != 'undefined' && typeof window.show_multiple_currencies != 'undefined' && window.show_multiple_currencies) {
                    Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                }
            }
        },

        isRunningInIframe: function() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        }
    };
})(jQuery);